import { ChangeDetectorRef, Component, DestroyRef, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { CourseService, Certificate } from './course.service';
import { IconComponent } from '../shared/components/icon/icon.component';

@Component({
  selector: 'app-certificate-viewer',
  standalone: true,
  imports: [CommonModule, RouterModule, IconComponent],
  templateUrl: './certificate-viewer.component.html',
  styleUrls: ['./certificate-viewer.component.scss']
})
export class CertificateViewerComponent implements OnInit {
  private destroyRef = inject(DestroyRef);

  certificate: Certificate | null = null;
  isLoading = true;
  errorMessage: string | null = null;

  constructor(
    private route: ActivatedRoute,
    private courseService: CourseService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    const certificateId = this.route.snapshot.paramMap.get('id');
    if (!certificateId) {
      this.errorMessage = 'No certificate ID provided';
      this.isLoading = false;
      return;
    }
    
    this.loadCertificate(certificateId);
  }

  loadCertificate(certificateId: string): void {
    this.courseService.getCertificate(certificateId).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
      next: (certificate) => {
        this.certificate = certificate;
        this.isLoading = false;
        this.cdr.markForCheck();
      },
      error: (error) => {
        console.error('Error loading certificate:', error);
        this.errorMessage = 'Failed to load certificate. Please try again later.';
        this.isLoading = false;
        this.cdr.markForCheck();
      }
    });
  }

  printCertificate(): void {
    window.print();
  }
} 